import React, { FC } from 'react';

import { FlexItem } from '../../../Flex';
import AppLayoutRow from '../../AppLayoutRow';

const subHeaderHeight = 44;

const SubHeader: FC = ({ children }) => (
  <AppLayoutRow height={subHeaderHeight}>
    <FlexItem grow={1} height={subHeaderHeight}>
      {children}
    </FlexItem>
  </AppLayoutRow>
);
export default SubHeader;
